import { render, staticRenderFns } from "./TakipAltTipInfo.vue?vue&type=template&id=1a0b4f9d"
import script from "./TakipAltTipInfo.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports